module.exports = __webpack_public_path__ + "img/icon_search_white.f2160efb.svg";